import { HttpErrorResponse } from '@angular/common/http'
import { ErrorHandler, Injectable, NgZone } from '@angular/core'
import { ToastService } from '@service/toast.service'
import { EcoTimeoutError } from './eco-timeout-error'

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  constructor(private zone: NgZone, private toastService: ToastService) {}

  handleError(e: any) {
    // 원본 에러 보존
    const originalError = e
    console.error('[GlobalErrorHandler]', originalError)

    if (!(e instanceof HttpErrorResponse) && e.rejection) e = e.rejection
    else e = e.message

    this.zone.run(() => {
      if (e instanceof EcoTimeoutError) {
        this.toastService.error('인터넷 연결이 원활하지 않습니다. 잠시 후 다시 시도해 주세요.')
        return
      }
    })
  }
}
